module.exports = __webpack_public_path__ + "static/CanelaDeck-Light-5b7fe0714b35b20647f3b44535b0e39b.woff";